
<app-table
module="roles"
pageTitle="Elenco ruoli"
newRecordUrl="roles/role-edit/new"
editRecordUrl="roles/role-edit/update/"
deleteRecordUrl="roles/role-edit/delete/"
listUrl="auth/roles_listall"
listParams="{}"></app-table>
	